import axios from "axios";

import myConfig from "../configs/config";
import { normalizeViewport } from "./mapViewport";

function authHeaders() {
  return {
    Authorization: `Bearer ${localStorage.getItem("client-token")}`,
  };
}

export async function saveFarmMapViewport(farmId, viewport) {
  const normalized = normalizeViewport(viewport);
  if (!normalized) {
    throw new Error("Viewport inválido");
  }

  const response = await axios.put(
    `${myConfig.API_URL}/farm/${farmId}/map-viewport/`,
    normalized,
    { headers: authHeaders() }
  );
  return normalizeViewport(response.data);
}
